import { createSelector } from '@ngrx/store';
import { getMemberFormFields } from '../getMemberFormFields';

export const getSignupMemberFormFields = createSelector(getMemberFormFields, (MemberFormFieldsModel) => MemberFormFieldsModel.signup);
